import { NavLink, useActionData } from 'react-router-dom';
import { ConfirmAccount } from '../repo/AccountsRepo';

export default function AccountConfirm() {
  const reponseData = useActionData()

  return (
    <section>
      <div className="container mx-auto flex flex-col items-center justify-between lg:w-6xl">
      {reponseData && reponseData.errors && (
        <div className="p-4 m-8 text-red-800 border border-red-300 rounded-lg bg-red-50" role="alert">
          <div className="flex items-center">
            <svg className="shrink-0 inline w-4 h-4 me-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
            </svg>
            <span className="sr-only">Info</span>
            <h3 className="text-lg font-medium">Erro!</h3>
          </div>
          <div className="mt-2 mb-4 text-sm">
            Ocorreu um problema com seu processo de confirmação de senha. Confirme o link recebido em seu email e tente novamente.
          </div>
        </div>
      )}
      {!reponseData && (
        <div className="p-4 m-8 text-green-800 border border-green-300 rounded-lg bg-green-50" role="alert">
          <div className="flex items-center">
            <svg className="shrink-0 w-4 h-4 me-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
            </svg>
            <span className="sr-only">Info</span>
            <h3 className="text-lg font-medium">Cadastro realizado com sucesso!</h3>
          </div>
          <div className="mt-2 mb-4 text-sm">
            Sua conta foi confirmada com sucesso, você pode fazer login e usar o melhor Bolão da internet.
          </div>
          <div className="flex">
            <NavLink to="/sign_in" className={"text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5"}>Fazer login</NavLink>
          </div>
        </div>
      )}
      </div>
    </section>
  )
}

export async function confirmAccount({request}) {
  const searchParams = new URL(request.url).searchParams
  const token = searchParams.get('token') || ''

  return await ConfirmAccount(token);
}
